// Supabase browser client — owns identity (anonymous guest, email/password,
// Google). The URL + anon key are public-safe and injected at build time via
// Vite env (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY). The session (and its
// auto-refreshing access token) is persisted by the SDK in localStorage; the
// game's api() helper reads the live token off it for every backend call.

import { createClient } from '@supabase/supabase-js'

// Optional-chain the env so importing this module outside Vite (Node tests,
// SSR) doesn't throw on an undefined import.meta.env — Vite still injects the
// real values in the browser build.
const env = import.meta.env ?? {}
const url = env.VITE_SUPABASE_URL
const anonKey = env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  console.warn('[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set — auth will not work. See .env.example.')
}

export const supabase = createClient(url ?? 'http://localhost', anonKey ?? 'missing', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // needed for the Google OAuth redirect handoff
  },
})
